//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import BuildingService from '@/service/building'
import PublicService from '@/service/public'
import TipService from '@/service/top_tip'
import detailSubPage from '@/common/mixins/detailSubPage'
import Data from '@/data/house_price'

import ListPage from './_list_page'
import BlockPage from './_block_page'
import CommonFooter from '../_components/_common_footer'
import Tip from './_tip'
import PriceQr from './price_qr'
const MODE = {
    LIST: 'list',
    BLOCK: 'block'
}

const SWITCH_BTN_MAP = {
    [MODE.BLOCK]: {
        icon: 'list',
        text: '列表'
    },
    [MODE.LIST]: {
        icon: 'building',
        text: '楼栋'
    }
}

export default {
    mixins: [
        detailSubPage,
    ],
    data () {
        return {
            title: '',
            id: '',
            mode: MODE.LIST,
            show_tip: false,
            tip_step: 0,
            show_switch_btn: false,
            show_price_graph: false,
            building: {},
            bottom_select_show: false,
            favourite: false,
            price_scene_qrcode_url: ''
        }
    },
    computed: {
        graph_link () {
            const { building_id } = this.$route.query || {}
            return `/building/price_graph?house_id=${this.id}&building_id=${building_id}`
        },
        show_list () {
            return this.mode === MODE.LIST
        },
        show_block () {
            return this.mode === MODE.BLOCK
        },
        switch_btn () {
            return SWITCH_BTN_MAP[this.mode]
        },
        show_block_cell_tip () {
            return this.show_tip && this.tip_step === 1
        }
    },
    created () {
        const options = this.$route.query
        this.title = options.title
        this.id = this.$route.query.house_id
        this.getBuilding()
        this.checkTip()
        this.getMode()
        this.show_switch_btn = true
    },
    onUnload () {
        this.setMode()
    },
    onReachBottom () {
        if (this.show_list) {
            this.getList()
        }
    },
    methods: {
        async getBuilding () {
            const { building_id, house_id } = this.$route.query || {}
            this.building = await BuildingService.getBuilding(building_id, {house_id})
            this.favourite = Boolean( this.building.follow_info &&  this.building.follow_info.id)
            this.title = this.building.name
            if (this.building.current_houses && this.building.current_houses.length) {
                const current_house = this.building.current_houses[0]
                this.show_price_graph = current_house.price_diagram && current_house.price_diagram.diagram_url
                this.price_scene_qrcode_url = current_house.price_scene_qrcode_url
                console.log(current_house.price_scene_qrcode_url);
            }
        },
        setMode () {
            Data.setMode(this.id, this.mode)
        },
        getMode () {
            Data.getMode(this.id).then((mode) => {
                this.mode = mode || MODE.LIST
            })
        },
        checkTip () {
            TipService.checkTip('block_mode_house_prices').then((tip_id) => {
                if (tip_id) {
                    this.show_tip = true
                    TipService.viewTips(tip_id)
                }
            })
        },
        call () {
            this.$showCallModal(this.getPhoneCall)
        },
        getPhoneCall () {
            const { building_id } = this.$route.query
            PublicService.getPhonePosition({
                building_id
            }).then(({ phone }) => {
                this.$wx.makePhoneCall({
                    phoneNumber: phone,
                    success: () => {}
                })
            })
        },
        changeMode () {
            this.mode = this.mode === MODE.LIST ? MODE.BLOCK : MODE.LIST
            if (this.mode === MODE.BLOCK) {
                this.changeTipStep(1)
            }
        },
        toggleShowTip () {
            this.show_tip = !this.show_tip
        },
        changeTipStep (step) {
            this.tip_step = step
        },
        getList () {
            this.$refs.list_page.reachBottom()
        },
        goDetail (id) {
            const { title, house_id, building_id, type } = this.$route.query
            this.$router.push({
                path: `/building/price_detail?price_id=${id}&title=${title}&building_id=${building_id}&house_id=${house_id}&type=${type || ''}`
            })
        },
        showSelect (show) {
            this.bottom_select_show = show
        },
        changeFavourite () {
            this.favourite = !this.favourite
        }
    },
    components: {
        ListPage,
        BlockPage,
        Tip,
        CommonFooter,
        PriceQr
    }
}
